import { render, staticRenderFns } from "./BonChef.vue?vue&type=template&id=5785eb9e"
import script from "./BonChef.vue?vue&type=script&lang=js"
export * from "./BonChef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports